import React, { FC } from "react";
import { XUIIconButton } from "@xero/xui/react/button";
import infoIcon from "@xero/xui-icon/icons/info";
import XUIPopover, { XUIPopoverBody } from "@xero/xui/react/popover";


export const InfoPopover: FC<{}> = ({ children }) => {
    const triggerRef = React.useRef(null);

    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const closePopover = () => setIsPopoverOpen(false);
    const togglePopover = () => setIsPopoverOpen(!isPopoverOpen);

    return (
        <>
            <XUIIconButton
                aria-owns={isPopoverOpen ? 'informational-popover' : undefined}
                ref={triggerRef}
                aria-haspopup={true}
                onClick={togglePopover}
                icon={infoIcon}
                size="xsmall"
                ariaLabel="More info"
            />
            {isPopoverOpen && (
                <XUIPopover
                    id="informational-popover"
                    preferredPosition="right"
                    triggerRef={triggerRef}
                    onClickOutside={closePopover}
                >
                    <XUIPopoverBody>
                        {children}
                    </XUIPopoverBody>
                </XUIPopover>
            )}
        </>
    );
};
